module.exports = __webpack_public_path__ + "img/7800.03b29a97.jpg";